
import { axios } from '@/utils/request'

const api = {
  options: '/wyhadminapi/caipan/options',
  getApplyList: '/wyhadminapi/caipan/shengCpManageList',
  getMemberList: '/wyhadminapi/caipan/shengCpList',
  checkShengMemberOK: '/wyhadminapi/caipan/checkShengMemberOK',
  shengcpApply: '/wyhadminapi/caipan/shengcpApply',
  shengApplyDetail: '/wyhadminapi/caipan/shengApplyDetail',
  xlsxImport: '/wyhadminapi/caipan/xlsxImport',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}
export function getApplyList(parameter) {
  return axios({
    url: api.getApplyList,
    method: 'get',
    params: parameter
  })
}
export function getMemberList(parameter) {
  return axios({
    url: api.getMemberList,
    method: 'get',
    params: parameter
  })
}
export function checkShengMemberOK(parameter) {
  return axios({
    url: api.checkShengMemberOK,
    method: 'post',
    data: parameter
  })
}
export function shengcpApply(parameter) {
  return axios({
    url: api.shengcpApply,
    method: 'post',
    data: parameter
  })
}
export function xlsxImport(parameter) {
  return axios({
    url: api.xlsxImport,
    method: 'post',
    headers: {
      'Content-Type':'multipart/form-data'
    },
    data: parameter
  })
}
export function getShengApplyDetail(parameter) {
  return axios({
    url: api.shengApplyDetail,
    method: 'post',
    data: parameter
  })
}
